// eslint-disable-next-line no-restricted-imports
import {Box} from '@chakra-ui/react';
import {FeaturedProductsBanner} from '../featured-products-banner';
import {ReleaseTimeline} from '../release-timeline';
import {SectionTitle} from '../section-title';
import {Video} from '../video';
import {ImageCarousel} from '../image-carousel';
import {FeaturedImage} from '../featured-image';
import {ImageWithTextSection} from '../image-with-text-section';
import {PartnershipBanner} from '../partnership-banner';
import {Timeline} from '../timeline-banner';
import {QuoteBlockBanner} from '../quote-block-banner';
import {FAQs} from '../../global/faq';
import {StoryCarousel} from '../story-carousel';
import {LeftRightColumnText} from '../left-right-column-text';

interface ProductComponentLoaderProps {
  primaryColor: string;
  secondaryColor: string;
  component: string;
  section: any;
}

export const ProductComponentLoader: React.FC<ProductComponentLoaderProps> = ({
  section,
  component,
  secondaryColor,
}) => {
  switch (component) {
    case 'product_carousel':
      return (
        <Box py={{base: '50px', md: '100px'}} bg={section.backgroundColor}>
          <FeaturedProductsBanner
            items={section.selectedAssets}
            heading={section.heading}
          />
        </Box>
      );
    case 'horizontal_timeline':
      return (
        <ReleaseTimeline
          accent={secondaryColor}
          items={section.timeline}
          heading={section.heading}
          background={section.backgroundColor}
        />
      );
    case 'video':
      return (
        <Video
          url={
            section.videoContent[0]?.embedVideo?.url ??
            section.videoContent[0].url
          }
          isEmbedded={!!section.videoContent[0]?.embedVideo}
          button={
            section.buttonText && section.buttonLink
              ? {text: section.buttonText, url: section.buttonLink}
              : undefined
          }
          thumbnail={section.videoContent[0]?.thumbnail?.url}
          caption={section.caption}
          background={section.backgroundColor}
        />
      );
    case 'title':
      return (
        <SectionTitle
          title={section.title}
          background={section.backgroundColor}
        />
      );
    case 'image_carousel':
      return (
        <ImageCarousel
          images={section.imageCarousel}
          background={section.backgroundColor}
        />
      );
    case 'featured_image':
      return (
        <FeaturedImage
          image={section.image.responsiveImage}
          caption={section.caption}
          background={section.backgroundColor}
        />
      );
    case 'image_and_text_block_section':
      return (
        <ImageWithTextSection
          image={section.image.responsiveImage}
          text={section.structuredText.value}
          textStyle={section.textStyle}
          imageSide={section.imagePosition}
          imagePositionMobile={section.imagePositionMobile}
          background={section.backgroundColor}
          centerTextMobile={section.centerTextMobile}
        />
      );
    case 'partnership_banner':
      return (
        <PartnershipBanner
          desktopImage={section.desktopLogo.responsiveImage}
          mobileImage={section.mobileLogo.responsiveImage}
          reverseColor={section.backgroundColourSide !== 'right'}
          content={section.text.value}
          primaryColor={section.backgroundColour.hex}
          copyColor={section.textColor === 'light' ? 'white' : 'charcoal'}
          linkCopy={section.buttonText}
          linkUrl={section.buttonLink}
        />
      );
    case 'step_process_banner':
      return (
        <Timeline
          items={section.steps}
          heading={section.heading}
          background={section.backgroundColor}
        />
      );
    case 'faq_story_placeholder':
      return (
        <Box pb={100}>
          <FAQs title={section.heading} />
        </Box>
      );
    case 'quote_block_banner':
      return (
        <QuoteBlockBanner
          quote={section.quote}
          cite={section.cite}
          background={section.backgroundColor}
        />
      );
    case 'story_carousel':
      return (
        <StoryCarousel
          title={section.title}
          storyContent={section.storyContent}
        />
      );
    case 'left_right_text_column':
      return (
        <LeftRightColumnText
          columnTitle={section.columnTitle}
          leftColumn={section.leftColumn}
          rightColumn={section.rightColumn}
        />
      );
    default:
      return <></>;
  }
};
